import { render, staticRenderFns } from "./AlarmItem.vue?vue&type=template&id=47380566"
import script from "./AlarmItem.vue?vue&type=script&lang=js"
export * from "./AlarmItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports